import { Trans } from '@lingui/macro'
import { Paper, Typography } from '@material-ui/core'
import { css } from 'emotion'
import React from 'react'

import { CenterContainer } from '../atoms/CenterContainer'
import { FailureText } from '../atoms/FailureText'

interface IProps {
  reason?: string
}

const paper = css`
  position: fixed;
  display: flex;
  flex-direction: column;
  top: 30%;
  padding: 1rem;
  max-width: 28rem;
`

export const AccountIsBlocked: React.FC<IProps> = ({ reason }) => {
  return (
    <CenterContainer>
      <Paper className={paper}>
        <FailureText variant="h5">
          <Trans>Účet pro tento obchod byl pozastaven.</Trans>
        </FailureText>
        {reason && (
          <Typography variant="body1">
            <br />
            <Trans>Důvod</Trans>: <b>{reason}</b>
          </Typography>
        )}
      </Paper>
    </CenterContainer>
  )
}
